import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StickyPackageService {
  private stickyPackageVisible =new BehaviorSubject<boolean>(false);
  isStickyPackageVisible$=this.stickyPackageVisible.asObservable();

  setStickyPackageVisible(isVisible:boolean){
    this.stickyPackageVisible.next(isVisible);
  }
}
